import RoadLoader from '../classes/loaders/RoadLoader';

const roadLoader = new RoadLoader();

export default class RoadUploadStore {
  public publishing = false;
  public count = 0;
  public percent = 0;

  constructor() {
    roadLoader.on('updated', () => {
      this.count = roadLoader.roads.length;
    });
    roadLoader.on('percent_updated', (data: number) => {
      this.percent = Number(((data * 100 / roadLoader.roads.length) || 0).toFixed(2));
    });
  }

  public reset() {
    roadLoader.reset();
  }

  public publish() {
    this.publishing = true;
    roadLoader.publish().then(() => {
      this.publishing = false;
    }).catch(error => {
      // noop.
      this.publishing = false;
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/stores/RoadUploadStore.ts